import React from 'react'
import { TourOverlay as BaseTourOverlay, default as VirtualTourButton } from 'Pages/Main/Home/VirtualTour'
import { TOUR_STEPS, MODAL_RANGES } from './steps'

export function TourOverlay(props) {
	return <BaseTourOverlay {...props} modalRanges={MODAL_RANGES} />
}

export { TOUR_STEPS }
export default VirtualTourButton
